// src/QuotationMarksIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var QuotationMarksIcon = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "450",
    height: "318",
    viewBox: "0 0 450 318",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M312.36 165.487L417.754 165.487C415.956 249.672 395.282 263.552 330.787 294.198C323.371 297.803 320.899 305.374 325.393 311.503C329.663 317.452 339.326 319.435 346.742 315.83C422.698 279.776 449.215 257.784 449.215 153.048L449.215 55.8844C449.215 25.0587 417.979 0.181822 379.776 0.181819L312.36 0.181814C272.809 0.181811 242.921 24.1574 242.921 55.8844L242.921 109.964C242.921 141.511 272.809 165.487 312.36 165.487Z" }),
      /* @__PURE__ */ jsx("path", { d: "M69.2154 165.487L174.61 165.487C172.812 249.672 152.137 263.552 87.6425 294.198C80.2267 297.803 77.7548 305.374 82.2492 311.503C86.7436 317.452 96.1819 319.435 103.822 315.83C179.778 279.776 206.295 257.784 206.295 152.868L206.295 55.7041C206.295 24.8784 175.059 0.00153739 136.857 0.00153474L69.4401 0.00153006C29.8892 0.00152732 0.00128359 23.9771 0.00128009 55.7041L0.00127413 109.784C-0.223461 141.511 29.6644 165.487 69.2154 165.487Z" })
    ]
  }
);
export {
  QuotationMarksIcon
};
